exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1oBXZnQYQtPLDCEc6MpkDz{padding:30px 70px;display:flex;justify-content:flex-start;align-items:flex-start;font-size:18px;font-weight:bold}\n", ""]);
// Exports
exports.locals = {
	"main": "_1oBXZnQYQtPLDCEc6MpkDz"
};